import * as c from '../../constants';

const initialState = {
  status: c.ANONYMOUS,
  uid: null,
  displayName: null
};

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case c.LOGGED_IN:
      return {
        ...state,
        status: c.LOGGED_IN,
        uid: action.user.uid,
        displayName: action.user.displayName
      }
    case c.ATTEMPTING_LOGIN:
      return {
        ...state,
        status: c.ATTEMPTING_LOGIN,
        uid: null,
        displayName: 'guest'
      }
    case c.ANONYMOUS:
      return {
        ...state,
        status: c.ANONYMOUS,
        uid: null,
        displayName: 'guest'
      }
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/store/reducers/authentication.js
 **/